// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8":"c66f9f48","172":"a2490bc7","432":"3c731668"}[chunkId] + ".chunk.css";
};